<template>
  <div>
    <section>
      <aggregated-cards />
    </section>
    <div>
      <v-data-table
        :loading="loading"
        :items-per-page="meta.itemsPerPage || 10000"
        :headers="_headers"
        :items="list"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:item.name="{ item }">
          <div
            class="open-link"
            @click="openUserModal(item)"
          >
            {{ item?.name }}
          </div>
        </template>
        <!-- 
        <template v-slot:item.payment_method="{ item }">
          <div>
            {{ item?.paymentMethods.map((r) => r.method)?.join(", ") }}
          </div>
        </template> -->
      </v-data-table>
      <section
        v-if="list.length > 0"
        class="paginationFooterWrap mt-3"
      >
        <pagination
          v-if="meta.page"
          :sub-screen="0"
          :active-page="meta.page"
          :per-page="meta.itemsPerPage"
          :per-page-options="[]"
          :total-items="meta.totalItems"
          :last-page="meta.lastPage"
          @change="onPaginationChange"
        />
      </section>
    </div>

    <!-- User Modal -->
    <user-modal
      v-if="selectedRow?.id"
      :item="selectedRow"
      @close="() => (selected = null)"
    />
    <!-- User Modal -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {
    // Modal: () => import("@/components/Modals/Modal.vue"),
    Pagination: () => import("@/layouts/section/Pagination.vue"),
    AggregatedCards: () => import("../utils/AggregatedCards.vue"),
    UserModal: () => import("../utils/UserModal.vue"),
  },

  props: {
    filtersOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      options: { ...this.filtersOptions },
      selected: null,
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      loading: "usersAnalyticsDashboard/getLoading",
      meta: "usersAnalyticsDashboard/getMeta",
      list: "usersAnalyticsDashboard/getList",
    }),
    selectedRow() {
      return this.selected || {};
    },
    // options() {
    //   return {
    //     ...this.filtersOptions,
    //   };
    // },
    _headers() {
      const headers = [
        {
          text: this.$t("user_name"),
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("phone_number"),
          align: "left",
          sortable: true,
          value: "phone",
        },
        {
          text: this.$t("vehicle"),
          align: "left",
          sortable: false,
          value: "vehicle",
        },
        // {
        //   text: this.$t("tenant_name"),
        //   align: "left",
        //   sortable: false,
        //   value: "tenant_name",
        //   showAdmin: true,
        // },
        {
          text: this.$t("bookings"),
          align: "left",
          sortable: true,
          value: "bookings",
        },
        {
          text: this.$t("sessions"),
          align: "left",
          sortable: true,
          value: "sessions",
        },
        {
          text: this.$t("last_charge"),
          align: "left",
          sortable: true,
          value: "last_charge_display",
        },
        {
          text: this.$t("total_spent"),
          align: "left",
          sortable: true,
          value: "total_spend",
        },
        {
          text: this.$t("avg_cost"),
          align: "left",
          sortable: true,
          value: "avg_cost",
        },
        {
          text: this.$t("payment_method"),
          align: "left",
          sortable: true,
          value: "payment_methods",
        },
        // {
        //   text: this.$t("status"),
        //   align: "left",
        //   sortable: false,
        //   value: "status",
        // },
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },
  },
  watch: {
    // filtersOptions() {
    //   this.fetchData();
    // },
  },
  methods: {
    // fetchData() {
    // },

    onPaginationChange(val) {
      this.options = { ...this.options, ...val };
    },
    openUserModal(v) {
      this.selected = v;
    },
  },
};
</script>
